import React from 'react';
import { ComponentTextXLarge, pxToRem } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import styled from '@emotion/styled';

const InitialAvatar = styled.div<{ diameter: number; backgroundColor: string }>`
    width: ${({ diameter }) => pxToRem(diameter)};
    height: ${({ diameter }) => pxToRem(diameter)};
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const TitleText = styled(ComponentTextXLarge)<{ diameter: number }>(({ diameter }) => ({
    fontSize: pxToRem(diameter * 0.4),
}));

const ImageAvatar = styled.img(({ diameter }: { diameter: number }) => ({
    width: pxToRem(diameter),
    height: pxToRem(diameter),
    borderRadius: '50%',
    objectFit: 'cover',
}));

interface Props {
    diameter: number;
    user?: {
        firstName?: string | null;
        lastName?: string | null;
        avatar?: string | null;
        providerType?: unknown;
    } | null;
    className?: string; // allows us to wrap with styled
    image?: string;
    initials?: string;
}

export const Avatar: React.FC<Props> = ({ diameter, user, className, initials, image }) => {
    const imgSrc = image || user?.avatar;
    if (!!imgSrc) {
        return (
            <ImageAvatar
                className={className}
                src={imgSrc}
                diameter={diameter}
                alt={`${user?.firstName} ${user?.lastName}`}
            />
        );
    }

    if (initials) {
        return (
            <InitialAvatar className={className} diameter={diameter} backgroundColor="">
                <TitleText fontColor="gray05" diameter={diameter}>
                    {initials}
                </TitleText>
            </InitialAvatar>
        );
    }

    if (user) {
        const bgColor = 'providerType' in user ? colors.violet40 : colors.blue40;

        const a = user.firstName?.[0].toUpperCase();
        const b = user.lastName?.[0].toUpperCase();

        return (
            <InitialAvatar className={className} diameter={diameter} backgroundColor={bgColor}>
                <TitleText fontColor="gray05" diameter={diameter}>
                    {a}
                    {b}
                </TitleText>
            </InitialAvatar>
        );
    }
    return null;
};
